<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:0px;">I would like to acknowledge all friends and family who have read and supported the drafts of this novel and for always believing that ‘I could.’</p>
<br/>
<p style="text-indent:0px;">And once again, I acknowledge my beautiful wife and best friend, June, in Heaven, for assisting me in the writing process and always believing that ‘I would!’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?473326a1